import {
  getPage,
  getDetail,
  getClientPage,
  datevehicleInfoGrouplocalalarmlimit,
  datelocalalarmlimit,
} from '@/api/localalarmanalysisregulationserv'

export default {
  state: {
    state_LocalAlarmAnalysisRegulation_GetPageResult: null,
    state_LocalAlarmAnalysisRegulation_GetDetailResult: null,
    state_LocalAlarmAnalysisRegulation_GetClientPageResult: null,
    state_LocalAlarmAnalysisRegulation_DatevehicleInfoGrouplocalalarmlimitResult: null,
    state_LocalAlarmAnalysisRegulation_DatelocalalarmlimitResult: null,
  },
  mutations: {
    SET_LOCALALARMANALYSISREGULATION_GETPAGE_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisRegulation_GetPageResult = rst;
    },
    SET_LOCALALARMANALYSISREGULATION_GETDETAIL_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisRegulation_GetDetailResult = rst;
    },
    SET_LOCALALARMANALYSISREGULATION_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisRegulation_GetClientPageResult = rst;
    },
    SET_LOCALALARMANALYSISREGULATION_DATEVEHICLEINFOGROUPLOCALALARMLIMIT_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisRegulation_DatevehicleInfoGrouplocalalarmlimitResult = rst;
    },
    SET_LOCALALARMANALYSISREGULATION_DATELOCALALARMLIMIT_RESULT: (state, rst) => {
      state.state_LocalAlarmAnalysisRegulation_DatelocalalarmlimitResult = rst;
    },
  },
  actions: {
    LocalAlarmAnalysisRegulationServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISREGULATION_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISREGULATION_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocalAlarmAnalysisRegulationServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISREGULATION_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISREGULATION_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocalAlarmAnalysisRegulationServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocalAlarmAnalysisRegulationServ_DatevehicleInfoGrouplocalalarmlimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datevehicleInfoGrouplocalalarmlimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISREGULATION_DATEVEHICLEINFOGROUPLOCALALARMLIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISREGULATION_DATEVEHICLEINFOGROUPLOCALALARMLIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocalAlarmAnalysisRegulationServ_Datelocalalarmlimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datelocalalarmlimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCALALARMANALYSISREGULATION_DATELOCALALARMLIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCALALARMANALYSISREGULATION_DATELOCALALARMLIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_LocalAlarmAnalysisRegulation_GetPageResult: state => {
      return state.state_LocalAlarmAnalysisRegulation_GetPageResult;
    },
    get_LocalAlarmAnalysisRegulation_GetDetailResult: state => {
      return state.state_LocalAlarmAnalysisRegulation_GetDetailResult;
    },
    get_LocalAlarmAnalysisRegulation_GetClientPageResult: state => {
      return state.state_LocalAlarmAnalysisRegulation_GetClientPageResult;
    },
    get_LocalAlarmAnalysisRegulation_DatevehicleInfoGrouplocalalarmlimitResult: state => {
      return state.state_LocalAlarmAnalysisRegulation_DatevehicleInfoGrouplocalalarmlimitResult;
    },
    get_LocalAlarmAnalysisRegulation_DatelocalalarmlimitResult: state => {
      return state.state_LocalAlarmAnalysisRegulation_DatelocalalarmlimitResult;
    },
  }
}